;
define("item_relations_row.tpl", function(){});

